module.exports = __webpack_public_path__ + "images/thinking95ba3ce9d45b016d064453a565306194.gif";